module.exports = __webpack_public_path__ + "static/img/09震惊.0c14881.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/09震惊.gif
// module id = cCPQ
// module chunks = 0